var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_467_5717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12.7745V23.0488H5.13229H8.76457V21.9736V20.8984H6.40359H4.0426V12.7745V4.6506H15H25.9574V12.7745V20.8984H23.5359H21.1144V21.9736V23.0488H24.8072H28.5V12.7745V2.50016H15H1.5V12.7745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.28024 8.22248C6.7789 9.01098 7.33585 11.3765 9.03091 11.3765C10.0601 11.3765 10.8228 10.6716 10.8228 9.72779C10.8228 8.43753 9.43046 7.61319 8.28024 8.22248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2208 12.428L16.4773 15.4147L15.8599 14.447C15.5208 13.9213 14.976 13.0851 14.6491 12.5833L14.0679 11.6634L13.1235 14.0408L12.1912 16.4182L11.0894 16.4541L9.98766 16.4899L9.67286 15.4386C9.49124 14.8651 9.32174 14.3036 9.29752 14.2081C9.2612 14.1125 8.92219 14.7815 8.53474 15.6895C7.79618 17.4815 7.74775 17.5293 6.86389 17.5412L6.34326 17.5532V18.0908V18.6284H15.0123C21.9016 18.6284 23.6693 18.5926 23.6208 18.4731C23.5845 18.4014 22.7612 16.3466 21.7805 13.9094C20.8119 11.4842 20.0007 9.48904 19.9886 9.47709C19.9764 9.46514 19.1773 10.7913 18.2208 12.428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1233 22.8097V24.7093L11.8036 24.7451L10.4839 24.781L12.7359 27.1345L14.9879 29.5L16.574 27.8513C17.4337 26.9553 18.4628 25.8801 18.8624 25.4619L19.5767 24.7212H18.1964H16.8162L16.8525 22.8097L16.8888 20.8982H15H13.1233V22.8097Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_467_5717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(1.5 2.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgDownloadIcon);
export default __webpack_public_path__ + "static/media/imgDownloadIcon.e70b78e55d829e7417e215b604e44960.svg";
export { ForwardRef as ReactComponent };